import DashboardMain from "components/Dashboard/index.jsx";
import SetupPage from "components/SetupPage/index";
import DashboardTimeBased from "components/DashboardTimeBased/index";
import SignalStorageBattery from "../components/Reports/sims/ontario/signalStorageBattery.jsx";
import ReVAMPDashboard from "../components/Dashboard/ReVAMP_Dashboard/ReVAMPDashboard";
import AppFormGenContainer from "../components/diagnostics/AppFormGen/AppFormGen";
import LocomotiveOEM from "../components/LocomotiveOEMRecord/index.jsx";
import AssetView from "../components/AssetView";
import SupportPage from "../components/SupportPage/Index.jsx";
import NewDashboardMain from "../components/NewDashboard/NewDashboard.jsx";
import { isUserEmailInList } from "../components/MainPage/UserInfo.js";
import IMSManagement from "../components/IMS/IMSManagement";

const commonRoutes = () => {
  let commonRoutes = [
    { path: "/setup", component: SetupPage },
    { path: "/dashboard", component: DashboardMain },
    { path: "/batterycard", component: SignalStorageBattery },
    { path: "/appFormGen", component: AppFormGenContainer },
    { path: "/newdashboard", component: NewDashboardMain },
    {
      path: "/AssetView/:id/:tab?",
      component: AssetView,
    },
    { path: "/wims", component: IMSManagement },
    { path: "/", component: DashboardMain },
  ];
  let supportRoute = isUserEmailInList(["superadmin@timps.com", "admin@tektracking.com"])
    ? [{ path: "/support", component: SupportPage }]
    : [];
  return [...supportRoute, ...commonRoutes];
};

export default commonRoutes();



// WEBPACK FOOTER //
// ./src/routes/common.routes.js